import { render, staticRenderFns } from "./drawerMenu.vue?vue&type=template&id=5d447b6a&"
import script from "./drawerMenu.ts?vue&type=script&lang=ts&"
export * from "./drawerMenu.ts?vue&type=script&lang=ts&"
import style0 from "./drawerMenu.vue?vue&type=style&index=0&id=5d447b6a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports